import logoImage from "../../assest/images/logo-img.png"
import { Link } from "react-router-dom"
import prularo from "../../assest/myImages/PLURALO_LOGO_WEBSITE.png";
import backgroundImg from "../../assest/images/securitybg4.jpg"
import LastBox from "../../components/LastBox"
import ProviderList from "../../components/ProviderList";
import helper from "../../common/Helper";

const Index = ({ verify, state, changeValue, handlePaste, handlePasteButtonClick }) => {
    const { otp, error } = state;

    return (
        // <section className="loginSec" style={{ backgroundImage: `url(${backgroundImg})` }}>
        //     <div className="loginpart">
        //         <div className="container">
        //             <div className="loginBox optSection">
        //                 <div className="logoSec">
        //                     <a href="javascript:void(0)"><img src={logoImage} alt="logo-img" /></a>
        //                     <h4>Security Verification <br /> Requirements</h4>
        //                     <h6>Verify 2FA Code</h6>
        //                 </div>
        //                 <form onSubmit={verify}>
        //                     <div className="getOtpBox">
        //                         <input
        //                             type="text"
        //                             className="commonInput"
        //                             id="otp"
        //                             name="otp"
        //                             value={otp}
        //                             onChange={changeValue}
        //                             onPaste={handlePaste}
        //                             maxLength="6"
        //                         />
        //                         <a className="comYellowa" href="javascript:void(0)" onClick={(e) => handlePasteButtonClick(e)}>PASTE</a>

        //                         {error && error.otp && <span className="cus-err">{error.otp}</span>}
        //                     </div>
        //                 </form>
        //             </div>
        //             <LastBox />
        //         </div>
        //     </div>
        // </section>

        <div className="sq-wrapper">
            <div className="sq-left">
                <a href={helper.touristUrl} target="_blank"><img src={logoImage} alt="logo-img" className="logo-img" /></a>
                <div className="sq-form-section">
                    <h1 className="sq-heading">Security Verification Requirements
                    </h1>
                    <form onSubmit={verify}>
                        <div className="sq-input-wrap getOtpBox">
                            <label className="sq-label" htmlFor="sq-otp">Verify 2FA Code</label>
                            <div style={{position:"relative"}}>
                                <input id="sq-otp" className="sq-input no-icon" name="otp" type="text" value={otp} placeholder="" onChange={changeValue} onPaste={handlePaste} maxLength="6" required />
                                <a className="comYellowa" href="javascript:void(0)" onClick={(e) => handlePasteButtonClick(e)}>PASTE</a>
                                {error && error.otp && <span className="cus-err login-err">{error.otp}</span>}
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div className="sq-right">

                <div className="sq-right-content">
                    <h2 className="sq-hero-title">Welcome to the<br /> Supplier Portal</h2>

                    <div className="sq-quote-block">
                        <p className="sq-quote-text">Simplify tour management, monitor real-time reservations, and keep your explorers prepared for their next thrill. Everything you need to organize, grow, and scale your adventure offerings: all in one place.</p>
                    </div>
                </div>

                <div className="sq-logos-section">
                    <div className="sq-logos-divider"></div>
                    <div className="sq-logos-label">We work with</div>
                    <div className="sq-logos-row">
                        <ProviderList />
                    </div>
                </div>
            </div>
        </div>
    )

}
export default Index;